import { useQuery } from '@tanstack/react-query';

import {
  getEffectivePrice,
  type EffectivePrice,
  type PricedOccurrence,
} from '@/services/class';
import { useAuth } from '@/contexts/auth';

export type { EffectivePrice };

export const effectivePriceQueryKey = (
  classId: string | undefined,
  userId: string | null,
  occurrence: PricedOccurrence | null
) => [
  'effective-price',
  classId,
  userId,
  occurrence?.slot_id ?? null,
  occurrence?.override_slot_id ?? null,
  occurrence?.start_time ?? null,
];

export default function useEffectivePrice({
  class_id,
  occurrence = null,
  enabled = true,
}: {
  class_id: string | undefined;
  occurrence?: PricedOccurrence | null;
  enabled?: boolean;
}) {
  const { user } = useAuth();
  return useQuery({
    queryKey: effectivePriceQueryKey(
      class_id,
      user?.user_id ?? null,
      occurrence
    ),
    queryFn: () => getEffectivePrice({ class_id: class_id!, occurrence }),
    enabled: enabled && !!class_id,
    // The price counts held credits, which change on other pages.
    refetchOnMount: true,
  });
}
